/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'periodical': {
    width: 16,
    height: 16,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M865.7 1022.7h-708c-39.3 0-78.7-39.3-78.7-78.7V78.8C79 39.5 118.3.1 157.7.1h707.9c43.3 0 78.7 35.4 78.7 78.7V944c0 43.3-35.4 78.7-78.6 78.7zm-708-943.9V944h707.9V78.8H157.7zm0 0"/><path pid="1" d="M739.8 826.1H307.2c-23.6 0-39.3-15.7-39.3-39.3 0-23.6 15.7-39.3 39.3-39.3h432.6c23.6 0 39.3 15.7 39.3 39.3 0 23.5-15.7 39.3-39.3 39.3zm0-157.4H307.2c-23.6 0-39.3-15.7-39.3-39.3 0-23.6 15.7-39.3 39.3-39.3h432.6c23.6 0 39.3 15.7 39.3 39.3 0 23.6-15.7 39.3-39.3 39.3zm7.9-275.3c-11.8 0-19.7-3.9-27.5-11.8l-70.8-70.8-70.8 70.8c-11.8 11.8-27.5 15.7-43.3 7.9-15.7-3.9-23.6-19.7-23.6-35.4V39.5C511.7 15.9 527.4.2 551 .2s39.3 15.7 39.3 39.3v220.2l31.5-31.5c15.7-15.7 39.3-15.7 55.1 0l31.5 31.5V39.5c0-23.6 15.7-39.3 39.3-39.3C771.3.2 787 15.9 787 39.5v314.6c0 15.7-7.9 31.5-23.6 35.4-3.9 3.9-11.8 3.9-15.7 3.9zm0 0"/>'
  }
})
